<div
  class="igntr-theme fixed top-0 right-0 bottom-0 w-[100vw] md:w-[560px] bg-white z-[130] shadow-[-20px_0_60px_-30px_rgba(0,0,0,.25)] flex flex-col"
>
  <app-tenant-ms-graph-edit-form
    [msGraphOptions]="msGraphOptions"
    [tenantId]="tenantId"
    (optionsSubmit)="updateCreateMsGraphOptions($event)"
    (onCloseModal)="onCloseModall()"
  >
  </app-tenant-ms-graph-edit-form>
</div>
